import { IDeductionActivityRepository, IDeductionActivityRepositoryParams, IDeductionActivityRepositoryResponse } from "@/core/repositories/deduction";

export class GetDeductionActivityUseCase {
  constructor(private readonly deductionActivityRepository: IDeductionActivityRepository) {}

  async execute(params: IDeductionActivityRepositoryParams): Promise<IDeductionActivityRepositoryResponse> {
    return this.deductionActivityRepository.getActivities(params);
  }
}
